// extracted by mini-css-extract-plugin
module.exports = {"container":"breadcrumb_container__2jeNL","crumb":"breadcrumb_crumb__8xsP1","text":"breadcrumb_text__fg81S","phAnimation":"breadcrumb_phAnimation__neUoQ"};